import { searchQueryState } from '@/features/search/global-search/search.state';
import { trackSearchAddFlowOpened } from '@/lib/mixpanel/mixpanel';
import { modalState } from '@/state/modal.state';
import { IconButton } from '@/ui/button/icon-button';
import { Tooltip } from '@/ui/tooltip/tooltip';
import { PERMISSION } from '@/user/permissions/permission.type';
import { useUserPermissions } from '@/user/permissions/use-user-permissions';
import { useAtomValue, useSetAtom } from 'jotai';
import { useTranslation } from 'react-i18next';

export const ProjectActions = ({ projectId }: { projectId: string }) => {
  const { t } = useTranslation('projects');
  const setModalState = useSetAtom(modalState);
  const searchQuery = useAtomValue(searchQueryState);
  const { hasRequiredPermission } = useUserPermissions();
  const hasEditPermission = hasRequiredPermission(
    PERMISSION.ADD_COMPANIES_TO_PROJECTS,
  );

  if (!hasEditPermission) {
    return null;
  }

  return (
    <Tooltip content={t`addCompany.label`}>
      <IconButton
        variant="primary"
        icon="Plus"
        onClick={e => {
          e.stopPropagation();
          trackSearchAddFlowOpened({
            flow_type: 'addCompany',
            project_id: projectId,
            search_query: searchQuery.search ?? '',
          });
          setModalState({
            state: 'addCompany',
            projectId,
          });
        }}
      />
    </Tooltip>
  );
};
